<template>
  <div class="app-container">
    <div class="user-realname">
        <h2>{{dataList.realname}}</h2>
        <el-button type="warning" plain @click.native="resetPass()" style="width:100px">重设密码</el-button>
    </div>
    
    <h3><span style="vertical-align:top;">客户信息</span><el-button type="primary" plain size="small" @click.native="editUserItme()" style="width:60px;margin-left:20px;">编辑</el-button></h3>
    <div class="user-info">
        <el-row>
            <el-col :span="2"><div class="grid-content">用户名id：</div></el-col>
            <el-col :span="22"><div class="grid-content">{{dataList.username}}</div></el-col>
        </el-row>
        <el-row>
            <el-col :span="2"><div class="grid-content">手机号：</div></el-col>
            <el-col :span="22"><div class="grid-content">{{dataList.tel}}</div></el-col>
        </el-row>
        <el-row>
            <el-col :span="2"><div class="grid-content">身份证号：</div></el-col>
            <el-col :span="22"><div class="grid-content">{{dataList.idcard}}</div></el-col>
        </el-row>
        <el-row>
            <el-col :span="2"><div class="grid-content">公司名称：</div></el-col>
            <el-col :span="22"><div class="grid-content">{{dataList.company_name}}</div></el-col>
        </el-row>
    </div>

    <div class="user-project">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick" v-loading.fullscreen.lock="fullscreenLoading">
            <el-tab-pane v-for="(item, index) in projecList" :label="item.item_name" :name="item.id" :key="index">
                <div class="user-project-info">
                    <div class="user-project-add-but">
                        <h3><span style="vertical-align:top;">项目信息</span><el-button type="primary" plain size="small" @click.native="editProjectItme()" style="width:60px;margin-left:20px;">编辑</el-button></h3>
                        <el-button type="primary" icon="el-icon-plus" @click.native="handleForm">新增项目</el-button>
                    </div>
                    <div v-if="projecListPane[0]" class="upi-table">
                        <div class="upit-td">
                            <div class="upitt-label">项目编号</div>
                            <div class="upitt-value">{{projecListPane[0].item_number}}</div>
                        </div>
                        <div class="upit-td">
                            <div class="upitt-label">项目地址</div>
                            <div class="upitt-value">{{projecListPane[0].proid}}{{projecListPane[0].cityid}}{{projecListPane[0].areaid}}{{projecListPane[0].address}}</div>
                        </div>
                        <!-- <div class="upit-td">
                            <div class="upitt-label">地图定位</div>
                            <div class="upitt-value">{{projecListPane[0].coordinate}}</div>
                        </div> -->
                        <div class="upit-td">
                            <div class="upitt-label">项目备注</div>
                            <div class="upitt-value">{{projecListPane[0].remarks}}</div>
                        </div>
                        <div class="upit-td">
                            <div class="upitt-label">安装说明书</div>
                            <div class="upitt-value">
                                <div v-for="(item, index) in projecListPane[0].thumb" :key="index">
                                    <el-tooltip class="item" effect="dark" :content="item.filename" placement="top">
                                        <el-image v-if="item.ext == 'pdf'" style="width: 30px; height: 30px; margin-right: 10px;cursor:pointer" src="https://app.shengren.work/wanshuiqing/pdf.png" fit="cover" @click="openPDFVisible(item.path)"></el-image>
                                        <el-image v-else style="width: 30px; height: 30px; margin-right: 10px;cursor:pointer" :src="item.path" :preview-src-list="srcList" fit="cover"></el-image>
                                    </el-tooltip>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <hr style="height:1px;border:none;border-top:1px solid #DCDFE6;margin:30px 0;" /> 
            
                <div class="user-project-list">
                    <h3>设备列表</h3>
                    <div v-if="projecListPane[0]" class="user-project-list-itme clearfix">
                        <div v-for="(item, index) in projecListPane[0].equipment" :key="index">
                            <div class="upl-itme">
                                <div class="upl-itme-img" @click="routerPushSD(item.id)">
                                    <svg viewBox="0 0 36 36" width="200" height="200" xmlns="http://www.w3.org/2000/svg"><g :stroke="item.switch == 0 ? '#8E989C' : '#409EFF'" fill="none" fill-rule="evenodd"><rect stroke-width="1.7" x=".9" y="3.4" width="34.3" height="29.1" rx="6"/><path d="m20.5 13 1.7 1.8v4.8c0 2.3-1.9 4.3-4.2 4.3-2.3 0-4.2-2-4.2-4.3v-4.8l1.6-1.7.7.7-1.3 1.4v4.4c0 1.7 1.4 3.2 3.2 3.2 1.7 0 3.2-1.5 3.2-3.2v-4.4l-1.4-1.4.7-.7Zm3.3 6.6c0 3.2-2.6 5.9-5.8 5.9a5.9 5.9 0 0 1-5.8-6v-4.8l3-3 2 2.2-1.1 1v4.8c0 1 .8 2 1.8 2s1.9-1 1.9-2v-5h-1v5c0 .5-.4.9-.9.9a.8.8 0 0 1-.8-.9v-4.3l3.7-3.6 3 3v4.8Zm-5.9-7.7.7.6-.7.6-.6-.6.6-.6Zm3-1.6-1.6 1.5-1.4-1.4-1.3 1.4-1.4-1.5-4 4v5.3c0 3.8 3 7 6.8 7a7 7 0 0 0 6.9-7v-5.3l-4-4Z" stroke-width=".5" :fill="item.switch == 0 ? '#8E989C' : '#409EFF'"/><g stroke-linecap="round" stroke-width="1.3"><path d="m30 8.6 2.1 2M30 12l2.1 2.2M30 15.5l2.1 2M30 18.9l2.1 2M30 22.3l2.1 2.2M30 25.7l2.1 2.2"/></g><g stroke-linecap="round" stroke-width="1.3"><path d="m3.4 8.6 2.1 2M3.4 12l2.1 2.2M3.4 15.5l2.1 2M3.4 18.9l2.1 2M3.4 22.3l2.1 2.2M3.4 25.7l2.1 2.2"/></g></g></svg>
                                </div>
                                <div class="upl-itme-switch">
                                    <div class="upli-label">设备开关</div>
                                    <el-switch v-model="item.switch" active-color="#13ce66" inactive-color="#c1c1c1" @change="equipmentSwitch(item.id)" :data-index="index"></el-switch>
                                </div>
                                <div class="upl-itme-id">
                                    <div class="upli-label">设备id</div>
                                    <div>{{item.device_id}}</div>
                                </div>
                                <div class="upl-itme-name">
                                    <div class="upli-label">位置</div>
                                    <div>{{item.eq_name}}</div>
                                </div>
                                <div class="upl-itme-internet">
                                    <div class="upli-label">设备状态</div>
                                    <div>{{item.is_internet}}</div>

                                </div>
                            </div>
                        </div>
                        <div class="upl-itme">
                            <div class="upl-itme-icon" @click="onClickArrEquipment">
                                <div class="icon"><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="60" height="60"><path d="M909.5 960.3H113c-27.5 0-49.8-22.3-49.8-49.8V114c0-27.5 22.3-49.8 49.8-49.8h796.5c27.5 0 49.8 22.3 49.8 49.8v796.5c0 27.5-22.3 49.8-49.8 49.8zM760.2 487.4h-224v-224h-49.8v224h-224v49.8h224v224h49.8v-224h224v-49.8z" fill="#e6e6e6"></path></svg>
                                <div class="text">新增设备</div></div>
                            </div>
                        </div>
                    </div>
                </div>

                <hr style="height:1px;border:none;border-top:1px solid #DCDFE6;margin:30px 0;" /> 
            
                <div class="user-project-maintenance">
                    <h3>维保队信息</h3>
                    <el-table :data="projecListPane" row-key="id" :border="true" :header-cell-style="{background: '#f5f7fa'}" stripe style="width: 100%">
                        <el-table-column align="center" prop="wb_team.name" label="维保队">  </el-table-column>
                        <el-table-column align="center" prop="wb_team.realname" label="队长"> </el-table-column>
                        <el-table-column align="center" prop="wb_team.tel" label="联系方式"> </el-table-column>
                        <el-table-column align="center" label="更换团队" width="300">
                            <template slot-scope="scope">
                                <el-select v-model="replace_wteam_id" placeholder="更换团队" @change="repWbTeam(scope.row)">
                                    <el-option v-for="item in replace_wteam_options" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="操作" width="100">
                            <template slot-scope="scope">
                                <el-button @click="routerPushWD(scope.row),drawer = true" slot="reference" type="text" size="small">查看</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <hr style="height:1px;border:none;border-top:1px solid #DCDFE6;margin:30px 0;" /> 
            
                <div class="user-project-Patrol">
                    <h3>巡查队信息</h3>
                    <el-table :data="projecListPane" row-key="id" :border="true" :header-cell-style="{background: '#f5f7fa'}" stripe style="width: 100%">
                        <el-table-column align="center" prop="xc_team.name" label="巡查队"> </el-table-column>
                        <el-table-column align="center" prop="xc_team.realname" label="队长"> </el-table-column>
                        <el-table-column align="center" prop="xc_team.tel" label="联系方式"> </el-table-column>
                        <el-table-column align="center" label="更换团队" width="300">
                            <template slot-scope="scope">
                                <el-select v-model="replace_xteam_id" placeholder="更换团队"  @change="repXbTeam(scope.row)">
                                    <el-option v-for="item in replace_xteam_options" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="操作" width="100">
                            <template slot-scope="scope">
                            <el-button @click="routerPushXC(scope.row)" slot="reference" type="text" size="small">查看</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>

    

    <!--新增项目表单-->
    <el-dialog :title="formName" :visible.sync="addTuserVisible" :before-close="hideAddTuser" width="1200px" top="5vh">
        <el-form :model="formData" :rules="addTuserRules" :inline="true" ref="dataForm" label-width="150px">
            <div v-show="formItem === 0">
                <div class="itme-text">
                    <div class="label">团队ID：</div>
                        <div class="content">{{userData.username}}</div>
                </div>
                <div class="itme-text">
                    <div class="label">客户ID：</div>
                        <div class="content">{{userData.realname}}</div>
                </div>
                <div class="itme-text">
                    <div class="label">手机号：</div>
                        <div class="content">{{userData.tel}}</div>
                </div>

                <hr style="height:1px;border:none;border-top:1px solid #DCDFE6;margin:30px 0;" /> 
            
                <h3 class="el-dialog__title">完善项目信息</h3>

                <el-form-item label="项目ID：">
                    <div>{{formData.p_arr.item_number}}</div>
                </el-form-item>
                <el-form-item label="项目名称：" prop="p_arr.item_name" style="width:100%">
                    <el-input v-model="formData.p_arr.item_name" auto-complete="off" placeholder="请输入项目名称" style="width:400px"></el-input>
                </el-form-item>
                <el-form-item label="项目地址：" prop="p_arr.proCityArea" style="width:100%">
                    <el-cascader placeholder="请点击选择地址" :options="options" v-model="formData.p_arr.proCityArea" @change="handleChange" clearable style="width:400px"></el-cascader>
                </el-form-item>
                <el-form-item label="." prop="p_arr.address" style="width:100%">
                    <el-input v-model="formData.p_arr.address" type="textarea" :rows="2" maxlength="30" show-word-limit placeholder="请输入详细地址" style="width:400px"> </el-input>
                </el-form-item>
                <el-form-item label="备注说明：" style="width:100%">
                    <el-input v-model="formData.p_arr.remarks" type="textarea" :rows="6" maxlength="300" show-word-limit placeholder="请输入备注说明" style="width:400px"> </el-input>
                </el-form-item>
                <el-form-item label="安装图纸：" style="width:100%">
                    <el-upload ref="upload" :action="uploadAPI" :data="uploadData" :headers="uploadHeaders" list-type="picture-card" :multiple="false" :limit="uplimit" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-success="handleSuccess" :on-error="handleError" :before-upload="beforeUpload" accept=".pdf, .jpg, .jpeg, .gif, .png, .bmp">
                            <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible" append-to-body>
                        <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                </el-form-item>
            </div>
            <div v-show="formItem === 1">
                <div class="itme-text">
                    <div class="label">项目编号：</div>
                        <div class="content">{{formData.p_arr.item_number}}</div>
                </div>
                <div class="itme-text">
                    <div class="label">项目名称：</div>
                        <div class="content">{{formData.p_arr.item_name}}</div>
                </div>

                <hr style="height:1px;border:none;border-top:1px solid #DCDFE6;margin:30px 0;" /> 
            
                <h3 class="el-dialog__title">添加设备</h3>
                
                <div class="e-arr-itme" v-for="(item, index) in formData.e_arr" :key="index">
                    <el-form-item label="设备ID：" style="width:100%">
                        <div>{{item.device_id}}</div>
                    </el-form-item>
                    <div v-if="formItem === 1">
                        <el-form-item label="设备别称：" :prop="'e_arr.' + index + '.eq_name'" :rules="{required: true, message: '请输入设备别称', trigger: 'blur'}" style="width:100%">
                            <el-input v-model="item.eq_name" auto-complete="off" placeholder="请输入设备别称,用于区分每台设备的位置" style="width:400px"></el-input>
                        </el-form-item>
                        <el-form-item label="设备序号：" :prop="'e_arr.' + index + '.grm'" :rules="{required: true, message: '请输入设备序号', trigger: 'blur'}" style="width:100%">
                            <el-input v-model="item.grm" auto-complete="off" placeholder="请输入设备序号" style="width:400px"></el-input>
                        </el-form-item>
                        <el-form-item label="设备密码：" :prop="'e_arr.' + index + '.pass'" :rules="{required: true, message: '请输入设备密码', trigger: 'blur'}" style="width:100%">
                            <el-input v-model="item.pass" auto-complete="off" placeholder="请输入设备密码" style="width:400px"></el-input>
                        </el-form-item>
                        <el-form-item label="设备监控图片地址：" :prop="'e_arr.' + index + '.img'" :rules="{required: true, message: '请输入设备监控图片地址', trigger: 'blur'}" style="width:100%">
                            <el-input v-model="item.img" auto-complete="off" placeholder="请输入设备监控图片地址" style="width:400px"></el-input>
                        </el-form-item>
                    </div>
                    <el-form-item label="设备说明书：" style="width:100%">
                        <el-upload ref="upload" :action="uploadAPI" :data="uploadData" :headers="uploadHeaders" list-type="picture-card" :multiple="false" :limit="uplimit" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-success="handleSuccess" :on-error="handleError" :before-upload="beforeUpload" :objectBind="index" accept=".pdf, .jpg, .jpeg, .gif, .png, .bmp">
                                <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog :visible.sync="dialogVisible" append-to-body>
                            <img width="100%" :src="dialogImageUrl" alt="">
                        </el-dialog>
                    </el-form-item>
                    <button v-if="index > 0" type="button" class="el-dialog__headerbtn" @click="deleteItem(item, index)"><i class="el-dialog__close el-icon el-icon-close"></i></button>
                </div>
                <el-button @click.native="addItem" type="primary" plain icon="el-icon-plus">添加更多设备</el-button>
            </div>
            <div v-if="formItem === 2">
                <div class="itme-text">
                    <div class="label">项目编号：</div>
                        <div class="content">{{formData.p_arr.item_number}}</div>
                </div>
                <div class="itme-text">
                    <div class="label">项目名称：</div>
                        <div class="content">{{formData.p_arr.item_name}}</div>
                </div>

                <hr style="height:1px;border:none;border-top:1px solid #DCDFE6;margin:30px 0;" /> 
            
                <h3 class="el-dialog__title">关联维保 / 巡查团队</h3>
            
                <el-form-item label="维保团队" prop="team.wb_team_id" style="width:100%">
                <el-select v-model="formData.team.wb_team_id" placeholder="请选择">
                    <el-option v-for="item in wb_team_options" :key="item.id" :label="item.name" :value="item.id" style="width:400px"></el-option>
                </el-select>
                </el-form-item>
                <el-form-item label="巡查团队" prop="team.xc_team_id" style="width:100%">
                <el-select v-model="formData.team.xc_team_id" placeholder="请选择">
                    <el-option v-for="item in xc_team_options" :key="item.id" :label="item.name" :value="item.id" style="width:400px"></el-option>
                </el-select>
                </el-form-item>


            </div>

            
            <div class="dialog-footer">
                <el-button v-if="formItem > 0" type="info" plain @click.native="backBut(formItem-1)">
                    <span v-if="formItem === 1 ">上一步 编辑项目信息</span>
                    <span v-if="formItem === 2 ">上一步 编辑项目设备信息</span>
                </el-button>
                <el-button v-if="formItem <= 1" type="primary" @click.native="nextBut(formItem+1)">
                    <span v-if="formItem === 0">下一步 完善项目设备信息</span>
                    <span v-if="formItem === 1 ">下一步 完善维保 / 巡查信息</span>
                </el-button>
                <el-button v-if="formItem > 1" type="primary" @click.native="formSubmit()" :loading="formLoading" style="width:200px">提 交</el-button>
            </div>
        </el-form>
    </el-dialog>
    
    <!--新增设备表单-->
    <el-dialog title="客户信息" :visible.sync="addEquipmentVisible" :before-close="hideAddEquipment" width="1200px" top="5vh">
        <el-form :model="formEquipmentData" :rules="addEquipmentRules" :inline="true" ref="dataEquipmentForm" label-width="150px">
            <div v-if="equipmentData.user">
                <div class="itme-text">
                    <div class="label">姓名：</div>
                        <div class="content">{{equipmentData.user.realname}}</div>
                </div>
                <div class="itme-text">
                    <div class="label">客户ID：</div>
                        <div class="content">{{equipmentData.user.username}}</div>
                </div>
                <div class="itme-text">
                    <div class="label">手机号：</div>
                        <div class="content">{{equipmentData.user.tel}}</div>
                </div>
            </div>

            <hr style="height:1px;border:none;border-top:1px solid #DCDFE6;margin:30px 0;" /> 
        
            <h3 class="el-dialog__title">项目信息</h3>

            <div v-if="equipmentData.project">
                <div class="itme-text">
                    <div class="label">项目编号：</div>
                        <div class="content">{{equipmentData.project.item_number}}</div>
                </div>
                <div class="itme-text">
                    <div class="label">项目名称：</div>
                        <div class="content">{{equipmentData.project.item_name}}</div>
                </div>
            </div>

            <hr style="height:1px;border:none;border-top:1px solid #DCDFE6;margin:30px 0;" /> 
        
            <h3 class="el-dialog__title">新增设备信息</h3>


            <div v-if="equipmentData">
                <div class="e-arr-itme" v-for="(item, index) in formEquipmentData.e_arr" :key="index">
                    <el-form-item label="设备ID：" style="width:100%">
                        <div>{{item.device_id}}</div>
                    </el-form-item>
                    <el-form-item label="设备别称：" :prop="'e_arr.' + index + '.eq_name'" :rules="{required: true, message: '请输入设备别称', trigger: 'blur'}" style="width:100%">
                        <el-input v-model="item.eq_name" auto-complete="off" placeholder="请输入设备别称,用于区分每台设备的位置" style="width:400px"></el-input>
                    </el-form-item>
                    <el-form-item label="设备序号：" :prop="'e_arr.' + index + '.grm'" :rules="{required: true, message: '请输入设备序号', trigger: 'blur'}" style="width:100%">
                        <el-input v-model="item.grm" auto-complete="off" placeholder="请输入设备序号" style="width:400px"></el-input>
                    </el-form-item>
                    <el-form-item label="设备密码：" :prop="'e_arr.' + index + '.pass'" :rules="{required: true, message: '请输入设备密码', trigger: 'blur'}" style="width:100%">
                        <el-input v-model="item.pass" auto-complete="off" placeholder="请输入设备密码" style="width:400px"></el-input>
                    </el-form-item>
                    <el-form-item label="设备监控图片地址：" :prop="'e_arr.' + index + '.img'" :rules="{required: true, message: '请输入设备监控图片地址', trigger: 'blur'}" style="width:100%">
                        <el-input v-model="item.img" auto-complete="off" placeholder="请输入设备监控图片地址" style="width:400px"></el-input>
                    </el-form-item>
                    <el-form-item label="设备说明书：" style="width:100%">
                        <el-upload ref="upload" :action="uploadAPI" :data="uploadData" :headers="uploadHeaders" list-type="picture-card" :multiple="false" :limit="uplimit" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-success="handleSuccess" :on-error="handleError" :before-upload="beforeUpload" :objectBind="index" accept=".pdf, .jpg, .jpeg, .gif, .png, .bmp">
                                <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog :visible.sync="dialogVisible" append-to-body>
                            <img width="100%" :src="dialogImageUrl" alt="">
                        </el-dialog>
                    </el-form-item>
                    <button v-if="index > 0" type="button" class="el-dialog__headerbtn" @click="deleteEquipmentItem(item, index)"><i class="el-dialog__close el-icon el-icon-close"></i></button>
                </div>
                <el-button @click.native="addEquipmentItem" type="primary" plain icon="el-icon-plus">添加更多设备</el-button>
            </div>


            <div class="dialog-footer">
                <el-button type="primary" @click.native="formEquipmentSubmit()" :loading="formLoading" style="width:200px">提 交</el-button>
            </div>
        </el-form>
    </el-dialog>
    
    <!-- 动态增加项目 -->
    <div v-for="(item, index) in form.dynamicItem" :key="index">
        <el-form-item
            label="姓名"
            :prop="'dynamicItem.' + index + '.name'"
            :rules="{
                required: true, message: '姓名不能为空', trigger: 'blur'
            }"
        >
            <el-input v-model="item.name"></el-input>
        </el-form-item>
        <el-form-item
            label="手机号"
            :prop="'dynamicItem.' + index + '.phone'"
            :rules="[
                {required: true, message: '手机号不能为空', trigger: 'blur'},
                //{ pattern: /^1[34578]\d{9}$/, message: '目前只支持中国大陆的手机号码' }
            ]"
            >
            <el-input v-model="item.phone"></el-input>
        </el-form-item>
        <el-form-item>
            <i class="el-icon-delete" @click="deleteItem(item, index)"></i>
        </el-form-item>
    </div>



    <!-- 登录密码重置 -->
    <el-dialog title="登录密码重置" :visible.sync="dialogVisible0" width="550px" :before-close="handleClose0">
        <span>您将进行重置密码操作，重置后原登录密码将不可用，新登录密码为“123456”</span>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible0 = false">取 消</el-button>
            <el-button type="primary" @click="resetPassTuserItme">确 定</el-button>
        </span>
    </el-dialog>
    
    <!-- 编辑客户信息 -->
    <el-dialog title="编辑客户信息" :visible.sync="editUserVisible" :before-close="hideEditUserVisible" width="1200px" top="5vh">
        <el-form :model="editUserData" label-width="150px">
            <el-form-item label="客户ID：">
                <div>{{editUserData.username}}</div>
            </el-form-item>
            <el-form-item label="姓名：">
                <el-input v-model="editUserData.realname" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="手机号：">
                <el-input v-model="editUserData.tel" auto-complete="off" maxlength="11"></el-input>
            </el-form-item>
            <el-form-item label="身份证号：">
                <el-input v-model="editUserData.idcard" auto-complete="off" maxlength="18"></el-input>
            </el-form-item>
            <el-form-item label="公司名称：">
                <el-input v-model="editUserData.company_name" auto-complete="off" maxlength="18"></el-input>
            </el-form-item>
        </el-form>
        <div class="dialog-footer">
            <el-button type="primary" @click.native="editUserDataSubmit()" :loading="formLoading" style="width:200px">提 交</el-button>
        </div>
    </el-dialog>
    
    <!-- 编辑项目信息 -->
    <el-dialog title="编辑项目信息" :visible.sync="editProjectVisible" :before-close="hideProjectVisible" width="1200px" top="5vh">
        <el-form :model="editProjectData" ref="dataForm" label-width="150px">
            <el-form-item label="项目ID：">
                <div>{{editProjectData.item_number}}</div>
            </el-form-item>
            <el-form-item label="项目名称：">
                <el-input v-model="editProjectData.item_name" auto-complete="off" placeholder="请输入项目名称"></el-input>
            </el-form-item>
            <el-form-item label="项目地址：">
                <el-input v-show="inputShow === 0" v-model="editProjectDataCityArea" style="width:400px" @click.native="inputSelect"></el-input> 
                <el-cascader v-show="inputShow === 1" placeholder="请点击选择地址" :options="options" v-model="editProjectData.proCityArea" @change="handleChange" @blur="Blur" clearable style="width:400px"></el-cascader>
            </el-form-item>
            <el-form-item label=".">
                <el-input v-model="editProjectData.address" type="textarea" :rows="3" maxlength="30" show-word-limit placeholder="请输入详细地址"> </el-input>
            </el-form-item>
            <el-form-item label="备注说明：">
                <el-input v-model="editProjectData.remarks" type="textarea" :rows="6" maxlength="300" show-word-limit placeholder="请输入备注说明"> </el-input>
            </el-form-item>
            <el-form-item label="安装图纸：">
                <div v-for="(item, index) in editUserDataThumb" :key="index" style="display: inline-block;">
                    <el-tooltip class="item" effect="dark" :content="item.filename" placement="top">
                        <div v-if="item.ext == 'pdf'" style="width: 70px; height: 70px; margin-right: 10px;position: relative;">
                            <el-image style="width: 70px; height: 70px;" src="https://app.shengren.work/wanshuiqing/pdf.png" fit="cover"></el-image>
                            <span class="el-upload-list__item-actions">
                                <span class="el-upload-list__item-preview" @click="openPDFVisible(item.path)">
                                    <i class="el-icon-zoom-in"></i>
                                </span>
                                <span class="el-upload-list__item-delete" @click="deletePDFVisible(item.id)">
                                    <i class="el-icon-delete" style="display: block;"></i>
                                </span>
                            </span>
                        </div>
                        <div v-else style="width: 70px; height: 70px; margin-right: 10px;position: relative;">
                            <el-image style="width: 70px; height: 70px" :src="item.path" :preview-src-list="srcList" fit="cover"></el-image>
                            <span class="el-upload-list__item-actions">
                                <span class="el-upload-list__item-preview" @click="openPDFVisible(item.path)">
                                    <i class="el-icon-zoom-in"></i>
                                </span>
                                <span class="el-upload-list__item-delete" @click="deletePDFVisible(item.id)">
                                    <i class="el-icon-delete" style="display: block;"></i>
                                </span>
                            </span>
                        </div>
                    </el-tooltip>
                </div>

                <el-upload ref="upload" :action="uploadAPI" :data="uploadData" :headers="uploadHeaders" list-type="picture-card" :multiple="false" :limit="uplimit" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-success="handleSuccess" :on-error="handleError" :before-upload="beforeUpload" objectBind="editProject" accept=".pdf, .jpg, .jpeg, .gif, .png, .bmp">
                        <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible" append-to-body>
                    <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
            </el-form-item>
        </el-form>
        <div class="dialog-footer">
            <el-button type="primary" @click.native="editProjectDataSubmit()" :loading="formLoading" style="width:200px">提 交</el-button>
        </div>
    </el-dialog>


    <el-dialog title="预览" :visible.sync="viewPDFVisible" width="100%" height="100%" :before-close='closeDialog'>
        <div class="pdf">
          <pdf :src="pdfsrc" ></pdf>
       	</div>
    </el-dialog>


  </div>



  
</template>



<script>
    import {apiSetailsList,apiProjectList,apiProjectdist,apiProjectadd,apiEquipmentSwitch,isVerificationID,apiGetTeam,apiProjectaddSubmit,apiAddEquipment,apiAddEquipmentSubmit,apiReplaceWteam,apiReplaceXteam,apiReplaceWteamSubmit,apiReplaceXteamSubmit,apiUseredit,apiUsereditSubmit,apiProjectedit,apiProjecteditSubmit} from "../../api/views/customer";
    import {apiResetPassword} from "../../api/views/maintain";
    import { getCookie } from "../../utils/rules";
    import pdf from 'vue-pdf'
    const formDataJson = [{
        "device_id":"",//设备id
        "eq_name":"",//设备别称
        "grm":"",//设备序号
        "pass":"",//设备密码  
        "img":"",//图片地址          
        "thumb":[]//设备说明书,上传返回的数据表id
    }]
    export default {
        data () {
            return {
                uid: '',
                pid: '',
                dataList:[],
                projecList:[],
                projecListPane:[],
                activeName: 'first',

                formLoading: false,
                dialogVisible0:false,
                fullscreenLoading: false,

                value: null,
                form: {
                    name: '',
                    phone: ''
                },
                formRules: {
                    name: [{required: true, message: '请输入姓名', trigger: 'blur'}],
                    phone: [
                        {required: true, message: '请输入手机号', trigger: 'blur'},
                        //{ pattern: /^1[34578]\d{9}$/, message: '目前只支持中国大陆的手机号码' }
                    ]
                },
                addTuserVisible: false,
                userData: {},
                formData:{    
                    "user":{//客户信息
                        "uid": "" //用户数据表id
                    },
                    "p_arr":{//项目信息
                        "item_number": "",//项目id
                        "item_name": "",//项目名称
                        "proid": "",// 省份
                        "cityid": "" ,// 城市
                        "areaid": "" , //区县
                        "address": "" ,//项目地址
                        "remarks": "" ,//备注说明
                        "thumb": [] ,//安装图纸,上传返回的数据表id
                        "coordinate":"",//坐标
                        proCityArea: []
                    },
                    "e_arr":[],//设备信息,
                    "team":{
                        "wb_team_id":"",//维保团队数据表id
                        "xc_team_id":""//巡查团队数据表id
                    }
                },
                addTuserRules: {
                    p_arr: {
                        item_name: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
                        proCityArea:[{ required: true, message: "请选择地址", trigger: "blur" }],
                        address: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
                    },
                    e_arr:{
                        eq_name:[{ required: true, message: "设备别称", trigger: "blur" }],
                        grm:[{ required: true, message: "请输入设备序号", trigger: "blur" }],
                        pass:[{ required: true, message: "请输入设备密码", trigger: "blur" }],
                        img:[{ required: true, message: "请输入图片地址", trigger: "blur" }]
                    },
                    team:{
                        wb_team_id:[{ required: true, message: "请选择维保团队", trigger: "blur" }],
                        xc_team_id:[{ required: true, message: "请输巡查团队", trigger: "blur" }]
                    }
                },

                options: [],
                selectedOptions: [],
                cityArr: [], //城市列表
                areaArr: [], //区县列表
                province: "", //省
                city: "", //市
                area: "", // 区县,
                provinceCityArea: ['450000', '450100', '450102'], //选择器选择的省市区

                uploadAPIMap:{
                    0: process.env.VUE_APP_API_BASE + '/admin/index/padd_upload',
                    1: process.env.VUE_APP_API_BASE + '/admin/index/eadd_upload',
                    2: process.env.VUE_APP_API_BASE + '/admin/index/w_task_upload'
                },
                uploadAPI: '',  // 上传的Url地址 upload
                dialogImageUrl: '',
                dialogVisible: false,
                disabled: false,
                uploadData:{},
                uploadHeaders:{},
                uplimit: 9,
                fileSuffix:'',
                uploadSwitch: false,
                uploadReply: [],

                formItem: 0,
                formName: '新建项目',
                formNameMap:{
                    0:'新建项目',
                    1:'完善项目设备信息',
                    2:'完善项目维保 / 巡查信息'
                },
                srcList: [],

                addEquipmentVisible: false,
                equipmentData: {},
                formEquipmentData: {    
                    "user":{
                        "uid": "",
                        "pid": ""
                    },
                    "e_arr":[]
                },
                addEquipmentRules: {
                    e_arr:{
                        eq_name:[{ required: true, message: "设备别称", trigger: "blur" }],
                        grm:[{ required: true, message: "请输入设备序号", trigger: "blur" }],
                        pass:[{ required: true, message: "请输入设备密码", trigger: "blur" }],
                        img:[{ required: true, message: "请输入图片地址", trigger: "blur" }]
                    }
                },
                replace_wteam_id:'',
                replace_wteam_options:[],
                replace_xteam_id:'',
                replace_xteam_options:[],
                editUserVisible: false,
                editUserData: {},
                editProjectVisible: false,
                editProjectData: {},
                editProjectDataCityArea: '',
                inputShow: 0,
                editUserDataThumb: [],
                viewPDFVisible: false,
                pdfsrc: ''

            }
        },
        created:function() {
            if(this.$route.query.id){
                this.βgetApp.globalData.customerID = this.$route.query.id
                this.getList(this.$route.query.id)
            }else{
                this.getList(this.βgetApp.globalData.customerID)
            }
        },
        methods: {
            // 上传前钩子
            beforeUpload(file, fileList){
                const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
                const whiteList = ['pdf', 'jpg', 'jpeg', 'gif', 'png', 'bmp'];
                if (whiteList.indexOf(fileSuffix) === -1) {
                    this.$message({
                        message: "上传文件格式错误！",
                        type: "error"
                    })
                    return false;
                }
                // const isLt2M = file.size / 1024 / 1024 < 4;
                // if (!isLt2M) {
                //     this.$message({
                //         message: "上传文件大小不能超过 4MB！",
                //         type: "error"
                //     })
                //     return false;
                // }
                this.uploadData.upload = file
                this.fileSuffix = file.name.substring(file.name.lastIndexOf('.')+1)
                this.fileFormat = file.type.toString().split('/')
                console.log('filedfgsf',fileList)
            },
            // 上传成功的回调钩子
            handleSuccess(response, file, fileList , index){
                console.log(this.βimgBaseUrl+response.path)
                response.name = file.name
                this.uploadReply.push(response)
                if(this.fileFormat[0] == 'image') {
                    // file.url = file.url
                    file.url = this.βimgBaseUrl+response.path
                }else if(this.fileFormat[0] == 'video'){
                    file.url = 'http://app.shengren.work/wanshuiqing/video.png'
                }else if(this.fileSuffix == 'pdf'){
                    file.url = 'http://app.shengren.work/wanshuiqing/pdf.png'
                }else{
                    file.url = 'http://app.shengren.work/wanshuiqing/file.png'
                }
                console.log('index',index)
                console.log(this.formData.e_arr)
                if(this.formItem === 0) this.formData.p_arr.thumb.push(response.id)
                if(this.formItem === 1) this.formData.e_arr[index].thumb.push(response.id)
                if(this.addEquipmentVisible === true) this.formEquipmentData.e_arr[index].thumb.push(response.id)
                if(index == 'editProject') this.editProjectData.thumb.push(response.id)
            },
            // 上传失败的回调钩子
            handleError(response, file, fileList) {
                console.log('error-----------')
                // console.log(response)
                console.log(file)
                console.log('response',this.$refs.upload)
                // this.isImporting = false
                // this.$refs.upload.clearFiles()
            },
            // 移除文件钩子
            handleRemove(file, fileList) {
                const newArr = this.uploadReply.filter((item) => {
                    return !file.name.includes(item.name)
                })
                this.uploadReply = newArr
                console.log(file)
                console.log(newArr)
                console.log(this.uploadReply)
            },
            // 点击文件列表中已上传的文件时的钩子
            handlePictureCardPreview(file) {
                console.log(this.fileFormat[0])
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
                console.log(file.url)
                console.log(this.uploadReply)
                console.log(this.uploadFiles)
                console.log(this.clearFiles)
                console.log(this.fileList)
            },
            getList(query){
                this.uploadHeaders = {
                    "X-Adminid": getCookie('ADMIN-ID'),
                    "X-Token": getCookie('ADMIN-TOKEN')
                }
                console.log(getCookie('ADMIN-ID'))
                apiSetailsList({id:query}).then(res => {
                    console.log('getList',res)
                    this.dataList = res
                    this.replace_wteam_id = res.project.wb_team.id
                    this.replace_xteam_id = res.project.xc_team.id
                }).catch(err => {
                    console.log('获取列表-失败',err)
                })
                apiProjectList({id:query}).then(res => {
                    let data = res
                    for(let i = 0; i<data.length; i++) data[i].id= data[i].id.toString()
                    this.projecList = data
                    this.activeName = data[0].id
                    this.getApiProjectdist({uid:res[0].uid,pid:res[0].id})
                    this.uid = res[0].uid
                    this.pid = res[0].id
                }).catch(err => {
                    console.log('获取列表-失败',err)
                })
                apiReplaceWteam().then(res => {
                    console.log(res)
                    this.replace_wteam_options = res
                }).catch(err => {
                    console.log('获取列表-失败',err)
                })
                apiReplaceXteam().then(res => {
                    console.log(res)
                    this.replace_xteam_options = res
                }).catch(err => {
                    console.log('获取列表-失败',err)
                })
            },
            handleClick(tab, event) {
                // console.log(parseInt(tab.name, 10))
                let result = this.projecList.find((item) => {return item.id == tab.name})
                this.getApiProjectdist({uid:result.uid,pid:result.id})
                this.pid = result.id
                this.uid = result.uid
            },
            getApiProjectdist(query){
                this.fullscreenLoading = true;
                apiProjectdist(query).then(res => {
                    for(let i of res.equipment) i.switch = i.switch == '1' || i.switch == 1 ? true : false
                    for(let i of res.thumb) {
                        i.path = this.βimgBaseUrl+i.path
                        if(i.ext !== 'pdf') this.srcList.push(i.path)
                    }
                    this.projecListPane = []
                    this.projecListPane.push(res)
                    this.fullscreenLoading = false;
                }).catch(err => {
                    console.log('获取列表-失败',err)
                })
            },
            resetPass(){
                this.dialogVisible0 = !this.dialogVisible0
                this.resetPassTuserItmeId = this.βgetApp.globalData.customerID
            },
            resetPassTuserItme(){
                console.log(this.resetPassTuserItmeId)
                let data = {id:this.resetPassTuserItmeId}
                apiResetPassword(data).then(res => {
                console.log(data)
                    if (res.code == 0) {
                        this.$message({
                            message: res.message,
                            type: "success"
                        });
                        // 刷新列表
                        this.getList(this.βgetApp.globalData.customerID)
                        this.dialogVisible0 = !this.dialogVisible0
                    }else{
                        this.$message({
                            message: res.message,
                            type: "error"
                        })
                    }
                })
            },
            handleClose(done) {
                this.dialogVisible = !this.dialogVisible
            },
            handleClose0(done) {
                this.dialogVisible0 = !this.dialogVisible0
            },
            routerPushWD(row){
                console.log(row)
                this.$router.push({path:'/maintain/details',query:{id:row.mt_id}});
            },
            routerPushXC(row){
                console.log(row)
                this.$router.push({path:'/patrol/details',query:{id:row.pt_id}});
            },
            routerPushSD(row){
                console.log(row)
                this.$router.push({path:'equipment-details',query:{id:row}});
            },
            equipmentSwitch(e){
                const that = this, equipment = that.projecListPane[0].equipment
                let index = equipment.findIndex(value=>value.id == e),
                    onSwitch = equipment[index].switch?1:0,
                    switchtext = equipment[index].switch?'设备开机':'关闭设备'
                that.$confirm(switchtext, '提示',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then( async () => {
                    await onEquipmentSwitch()
                }).catch(_ => {
                    that.$message({
                        type: 'info',
                        message: '已取取消'+switchtext+'操作'
                    })
                    equipment[index].switch = !equipment[index].switch
                })
                function onEquipmentSwitch(){
                    apiEquipmentSwitch({id:e,switch:onSwitch}).then(res => {
                        console.log(res)
                        if(res.code!=1){
                            that.$message({
                                message: res.message,
                                type: "success"
                            });
                        }else{
                            that.$message({
                                message: res.message,
                                type: "error"
                            })
                            equipment[index].switch = !equipment[index].switch
                        }
                    })
                }
            },
            // 显示表单
            handleForm(index, row) {
                const that = this
                this.formItem = 0
                this.uploadReply = []
                this.addTuserVisible = true
                apiProjectadd({id:this.βgetApp.globalData.customerID}).then(res => {
                    console.log(res)
                    this.userData = res
                })
                apiGetTeam().then(res => {
                    console.log(res)
                    that.wb_team_options = res.wb_team_list
                    that.xc_team_options = res.xc_team_list
                })
                this.initDistPicker()
                // if (row !== null) this.formData = Object.assign({}, row)
                this.formData.e_arr = Array.from(formDataJson)
                this.formData.p_arr.item_number = this.random('XM',1,1000000)
                setTimeout( () => {
                    this.formData.e_arr[0].device_id = this.random('SB',1,1000000)
                }, 2000)
                this.formData.user.uid = this.βgetApp.globalData.customerID
                this.uploadAPI = this.uploadAPIMap[0]
                // 清空验证信息表单
                if (this.$refs["dataForm"]) {
                    this.$refs["dataForm"].clearValidate();
                }
                console.log(this.formData)
            },
            // 隐藏表单
            hideAddTuser() {
                // 更改值
                this.addTuserVisible = !this.addTuserVisible;
                this.$emit("onChange",this.addTuserVisible)
                // 清空表单
                this.$refs["dataForm"].resetFields();
                this.formData.e_arr = Array.from(formDataJson)
                this.uploadAPI = this.uploadAPIMap[0]
                this.formItem = 0
                this.uploadReply = []
                return true;
            },
            // 地区初始化
            initDistPicker() {
            let self = this;
            this.$http.get("./china-main-city/districts.json").then(function(respones) {
                console.log("respones==>", respones);
                let distData = respones.data;
                let options = [];
                // 省
                for (var provinceKy in distData["100000"]) {
                let optProvinceItem = {
                    value: provinceKy,
                    label: distData["100000"][provinceKy]
                };
                if (distData[provinceKy]) {
                    // 市
                    for (var cityKy in distData[provinceKy]) {
                    optProvinceItem.children = optProvinceItem.children
                        ? optProvinceItem.children
                        : [];
                    let optCityItem = {
                        value: cityKy,
                        label: distData[provinceKy][cityKy]
                    };
                    if (distData[cityKy]) {
                        // 区
                        for (var areaKy in distData[cityKy]) {
                        optCityItem.children = optCityItem.children
                            ? optCityItem.children
                            : [];
                        let optAreaItem = {
                            value: areaKy,
                            label: distData[cityKy][areaKy]
                        };
                        optCityItem.children.push(optAreaItem);
                        }
                    }
                    optProvinceItem.children.push(optCityItem);
                    }
                }
                options.push(optProvinceItem);
                }
                self.distData = distData;
                self.options = options;
            });
            },
            //选择地区
            handleChange(value) {
                let self = this, PAll = self.formData.p_arr
                console.log("value=>", value);
                //获取省名
                self.options.map((item, index) => {
                    if (item.value == value[0]) {
                        self.cityArr = item.children; //存储城市列表
                        self.province = item.label;
                    }
                });
                //获取市名
                self.cityArr.map((item, index) => {
                    if (item.value == value[1]) {
                        self.areaArr = item.children; //存储区县列表
                        self.city = item.label;
                    }
                });
                //获取区县名
                self.areaArr.map((item, index) => {
                    if (item.value == value[2]) {
                        self.area = item.label;
                    }
                });
                self.provinceCityArea = self.province + self.city + self.area;
                PAll.proid = self.province
                PAll.cityid = self.city
                PAll.areaid =  self.area
                console.log(self.formData.p_arr)
                console.log(self.editProjectData.proCityArea)
                self.editProjectData.proid = self.province
                self.editProjectData.cityid = self.city
                self.editProjectData.areaid =  self.area
            },
            //
            backBut(index){
                this.formItem--
                this.formName = this.formNameMap[this.formItem]
                this.uploadAPI = this.uploadAPIMap[index]
            },
            //
            nextBut(index){
                const that = this
                this.$refs["dataForm"].validate(valid => {
                    if (valid) {
                        this.formItem++
                        this.formName = this.formNameMap[this.formItem]
                        this.uploadAPI = this.uploadAPIMap[index]
                    }
                })
            },
            addItem () {
                this.formData.e_arr.push({
                    device_id: this.random('SB',1,1000000),
                    "eq_name":"",
                    "grm":"",
                    "pass":"",
                    "img":"",        
                    "thumb":[]
                })
            },
            deleteItem (item, index) {
                this.formData.e_arr.splice(index, 1)
            },
            // 提交表单
            formSubmit() {
                this.$refs["dataForm"].validate(valid => {
                    if (valid) {
                        let newEallObj = {}, data = {}, newFormData = JSON.parse(JSON.stringify(this.formData))
                        this.formLoading = true
                        delete newFormData.p_arr['proCityArea']
                        newFormData.p_arr.coordinate = '108.33882,22.819822'
                        console.log(newFormData.p_arr)
                        if(newFormData.p_arr.thumb.length > 0) {
                            newFormData.p_arr.thumb = newFormData.p_arr.thumb.toString()
                        }else{
                            delete newFormData.p_arr['thumb']
                            newFormData.p_arr.thumb = ''
                        }
                        for(let i of newFormData.e_arr) {
                            if(i.thumb.length > 0)  i.thumb = i.thumb.toString()
                        }
                        newFormData.e_arr.forEach((item,index) => {
                            newEallObj[index] = item
                        })
                        newFormData.e_arr = newEallObj
                        data = newFormData
                        console.log(data)
                        apiProjectaddSubmit(data).then(response => {
                            this.formLoading = false;
                            console.log(response)
                            if (response.code == 0) {
                                this.$message({
                                    message: "操作成功",
                                    type: "success"
                                });
                                // 清空/隐藏表单
                                this.formItem = 0;
                                // this.$nextTick(()=>{this.$refs["dataForm"].resetFields()})
                                this.$refs["dataForm"].resetFields()
                                this.hideAddTuser()
                                // 刷新列表
                                this.getList(this.βgetApp.globalData.customerID)
                            } else {
                                this.$message({
                                    message: response.message,
                                    type: "error"
                                })
                            }
                        })
                    }
                });
            },
            // 随机客户ID/项目ID
            random(type, min, max) {
                const that = this,
                    num = type + Math.floor(Math.random() * (max - min)) + min,
                    queryMap = {
                        'KH':{username:num},
                        'XM':{item_number:num},
                        'SB':{device_id:num}
                    },
                    query = queryMap[type]
                ~function verusername() {
                    isVerificationID(type,query).then(res => {
                        if(res == 0){
                            return num
                        }else{
                           return verusername()
                        }
                    }).catch(() => {});
                }()
                return num
            },
            // 显示表单
            onClickArrEquipment(){
                let query = {
                    uid: this.uid,
                    pid: this.pid
                }
                this.formEquipmentData.user = query
                this.formEquipmentData.e_arr = Array.from(formDataJson)
                this.formEquipmentData.e_arr[0].device_id = this.random('SB',1,1000000)
                this.addEquipmentVisible = true
                apiAddEquipment(query).then(res => {
                    console.log(res)
                    this.equipmentData = res
                }).catch(err => {
                    console.log('获取列表-失败',err)
                })
                this.uploadAPI = this.uploadAPIMap[2]
                // 清空验证信息表单
                if (this.$refs["dataEquipmentForm"]) {
                    this.$refs["dataEquipmentForm"].clearValidate();
                }
                console.log(this.formEquipmentData)
            },
            // 隐藏表单
            hideAddEquipment(){
                this.addEquipmentVisible = false
                this.$emit("onChange",this.addEquipmentVisible)
                // 清空表单
                this.$refs["dataEquipmentForm"].resetFields();
                this.formData.e_arr = Array.from(formDataJson)
                this.uploadAPI = this.uploadAPIMap[0]
                this.uploadReply = []
                return true;
            },
            addEquipmentItem () {
                this.formEquipmentData.e_arr.push({
                    device_id: this.random('SB',1,1000000),
                    "eq_name":"",
                    "grm":"",
                    "pass":"",
                    "img":"",        
                    "thumb":[]
                })
            },
            deleteEquipmentItem (item, index) {
                this.formEquipmentData.e_arr.splice(index, 1)
            },
            formEquipmentSubmit(){
                this.$refs["dataEquipmentForm"].validate(valid => {
                    if (valid) {
                        console.log('formEquipmentData',this.formEquipmentData)
                        
                        console.log('uploadReply',this.uploadReply)
                        console.log('dialogImageUrl',this.dialogImageUrl)
                        console.log('dialogVisible',this.dialogVisible)
                        console.log('disabled',this.disabled)
                        console.log('uploadData',this.uploadData)
                        console.log('uplimit',this.uplimit)
                        console.log('fileSuffix',this.fileSuffix)
                        console.log('uploadSwitch',this.uploadSwitch)
                        // this.uploadData = []
                        
                        let newEallObj = {}, data = {}, newFormData = JSON.parse(JSON.stringify(this.formEquipmentData))

                        this.formLoading = true
                        
                        for(let i of newFormData.e_arr) {
                            if(i.thumb.length > 0)  i.thumb = i.thumb.toString()
                        }
                        newFormData.e_arr.forEach((item,index) => {
                            newEallObj[index] = item
                        })
                        newFormData.e_arr = newEallObj
                        data = newFormData
                        console.log(data)
                        apiAddEquipmentSubmit(data).then(response => {
                            this.formLoading = false;
                            console.log(response)
                            if (response.code == 0) {
                                this.$message({
                                message: "操作成功",
                                type: "success"
                                });
                                // 清空/隐藏表单
                                this.formItem = 0;
                                // this.$nextTick(()=>{this.$refs["dataForm"].resetFields()})
                                this.$refs["dataEquipmentForm"].resetFields()
                                this.hideAddEquipment()
                                // 刷新列表
                                this.getList(this.βgetApp.globalData.customerID)
                            } else {
                                this.$message({
                                    message: response.message,
                                    type: "error"
                                })
                            }
                        })
                    }
                })

            },
            repWbTeam(e){
                let data = {
                    pid: this.pid,
                    tid: this.replace_wteam_id
                }
                let itemName = this.replace_wteam_options.filter(item => item.id === this.replace_wteam_id)
                this.$confirm('是否要更换维保团队', '提示',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then( async () => {
                    await apiReplaceWteamSubmit(data).then(res => {
                        this.projecListPane[0].wb_team.name = itemName[0].name
                        this.$message({
                            message: res.message,
                            type: "success"
                        });
                    }).catch(err => {
                        this.$message({
                            message: res.message,
                            type: "error"
                        })
                    })
                }).catch(_ => {
                    this.$message({
                        type: 'info',
                        message: '操作取消'
                    })
                })
            },
            repXbTeam(e){
                let data = {
                    pid: this.pid,
                    tid: this.replace_xteam_id
                }
                let itemName = this.replace_xteam_options.filter(item => item.id === this.replace_xteam_id)
                this.$confirm('是否要更巡查保团队', '提示',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then( async () => {
                    await apiReplaceXteamSubmit(data).then(res => {
                        console.log(res)
                        this.projecListPane[0].xc_team.name = itemName[0].name
                        this.$message({
                            message: res.message,
                            type: "success"
                        });
                    }).catch(err => {
                        this.$message({
                            message: res.message,
                            type: "error"
                        })
                    })
                }).catch(_ => {
                    this.$message({
                        type: 'info',
                        message: '操作取消'
                    })
                })
            },
            editUserItme(row){
                console.log(row)
                console.log(this.uid)
                this.editUserVisible = true
                apiUseredit({id:this.uid}).then(res=>{
                    console.log(res)
                    this.editUserData = res
                })
            },
            hideEditUserVisible(){
                this.editUserVisible = false
            },
            editUserDataSubmit(){
                let data = this.editUserData
                this.editUserVisible = false
                console.log(data)
                apiUsereditSubmit(data).then(res=>{
                    console.log(res)
                    if (res.code === 0) {
                        this.$message({
                            message: res.message,
                            type: "success"
                        })
                        this.getList(this.βgetApp.globalData.customerID)
                    } else {
                        this.$message({
                            message: res.message,
                            type: "error"
                        })
                    }
                })
            },
            editProjectItme(){
                // 清空验证信息表单
                if (this.$refs["dataForm"] || this.$refs.upload ) {
                    this.$refs["dataForm"].clearValidate();
                    this.$refs.upload.clearFiles()
                }
                this.editProjectVisible = true
                this.initDistPicker()
                this.uploadAPI = this.uploadAPIMap[0]
                apiProjectedit({id:this.pid}).then(res=>{
                    console.log(res)
                    let arrID = []
                    this.editProjectData = res
                    this.editUserDataThumb = res.thumb
                    for(let i of this.editUserDataThumb){
                        i.path = this.βimgBaseUrl+i.path
                        arrID.push(i.id)
                    }
                    console.log(arrID)
                    this.editProjectData.thumb = arrID
                    this.editProjectDataCityArea = res.proid + ' / ' + res.cityid + ' / ' + res.areaid
                    console.log(this.editUserDataThumb)
                    
                })
            },
            hideProjectVisible(){
                this.editProjectVisible = false
                this.inputShow = 0
                this.$emit("onChange",this.editProjectVisible)
                // 清空表单
                this.$refs["dataEquipmentForm"].resetFields();
                this.$refs.upload.clearFiles()
                // this.editProjectData.proCityArea = null
                delete this.editProjectData['proCityArea']
                this.editUserDataThumb = []
                console.log(this.editProjectData)
            },
            editProjectDataSubmit(){
                let data = this.editProjectData
                data.thumb = data.thumb.toString()
                console.log(data)
                console.log(this.uploadReply)
                apiProjecteditSubmit(data).then(res=>{
                    console.log(res)
                    if (res.code === 0) {
                        this.editProjectVisible = false
                        this.editUserDataThumb = []
                        this.uploadReply = []
                        if (this.$refs["dataForm"]) this.$refs["dataForm"].resetFields()
                        this.$refs.upload.clearFiles()
                        this.$message({
                            message: res.message,
                            type: "success"
                        })
                        this.getList(this.βgetApp.globalData.customerID)
                    } else {
                        this.$message({
                            message: res.message,
                            type: "error"
                        })
                    }
                })
            },
            inputSelect(){
                this.inputShow = 1
            },
            Blur(){
                console.log(this.editProjectData.proCityArea)
            },
            closeDialog(){
                this.viewPDFVisible = false
            },
            openPDFVisible(row){
                // this.viewPDFVisible = true
                console.log(row)
                this.pdfsrc = pdf.createLoadingTask(row)
                window.open(row,"_blank")
            },
            deletePDFVisible(e){
                const editUserDataThumb = this.editUserDataThumb,
                    editProjectData = this.editProjectData.thumb,
                    index = editUserDataThumb.findIndex((item) => item.id === e)
                editUserDataThumb.splice(index, 1)
                editProjectData.splice(index, 1)
                this.editUserDataThumb = editUserDataThumb
                this.editProjectData.thumb = editProjectData
            }
        }
    }
</script>

<style lang="scss" scoped>
  .app-container{
    color: #1f2f3d;
  }
  .app-container h2{
    display: block;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
    font-weight: 400;
    color: #1f2f3d;
    font-size: 28px;
  }
  .app-container h3{
    display: block;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
    font-weight: 400;
    color: #1f2f3d;
    font-size: 22px;
  }
  .user-realname h2{
      display: inline-block;
      margin-right: 20px;
      vertical-align: sub;
  }
  .user-info{
      margin-bottom: 50px;
  }
  .user-info .el-row{
      margin: 10px;
      font-size: 14px;
  }
  .user-project-list-itme{
    width: 95%;
    margin: 0 auto;
    .upl-itme {
        float: left;
        width: 33%;
        .upl-itme-img{
            text-align: center;
            cursor:pointer;
            svg{
                width: 90%;
            }
        }
        .upl-itme-switch{
        display: flex;
        justify-content: space-between;
        align-items: center;
        }
        .upli-label{
            width: 80px;
            color: rgba(0, 0, 0, .6);
        }
        .upl-itme-icon{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-content: center;
            cursor:pointer;
            .icon {
                width: 200px;
                height: 200px;
                position: relative;
                border: 1px dashed #e6e6e6;
                svg{
                    position:absolute;top:40%;left:50%;transform:translate(-50%,-50%);justify-content: center; align-items: center;
                    width: 90%;
                }
                .text {
                    position:absolute;top:65%;left:50%;transform:translate(-50%,-50%);justify-content: center; align-items: center;
                    color: #000;
                }
            }
        }
    }
  }
  
  .upl-itme > div {
      width: 200px;
      margin: 20px 0;
      display: flex;
      justify-content: flex-start;
      align-items: center;
  }
  .upi-table{
      border: 1px solid #ebeef5;
      .upit-td{
          border-bottom: 1px solid #ebeef5;
          height: 50px;
          display: flex;
          align-items:center;
          .upitt-label{
            display: flex;
            justify-content:center;
            align-items:center;
            height: 50px;
            width: 150px;
            background: rgb(245, 247, 250);
            text-align: center;
            border-bottom: 1px solid #ebeef5;
          }
          .upitt-value{
            display: flex;
            align-items:center;
            height: 50px;
            padding: 0 20px;
          }
      }
  }
  .user-project-add-but {
    display: flex;
    justify-content:space-between;
    align-items:center;
  }
  .itme-text{
        display: flex;
        .label {
            width: 130px;
            text-align: right;
            float: left;
            font-size: 14px;
            color: #606266;
            line-height: 40px;
            padding: 0 12px 0 0;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            margin-left: 20px;
        }
        .content {
            flex: 1;
            line-height: 40px;
            position: relative;
            font-size: 14px;
        }
    }
  .itme-text label.el-form-item__label{
    width: 80px !important;
  }
  
  .dialog-footer{
      width: 100%;
  }
  .e-arr-itme {
    position: relative;
    border: 1px dashed #d9d9d9;
    margin: 30px 0;
    padding: 30px 0;
  }
  .el-upload-list__item-actions {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    cursor: default;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0,0,0,.5);
    -webkit-transition: opacity .3s;
    transition: opacity .3s
}

.el-upload-list__item-actions:after {
    display: inline-block;
    content: "";
    height: 100%;
    vertical-align: middle
}

.el-upload-list__item-actions span {
    display: none;
    cursor: pointer
}

.el-upload-list__item-actions span+span {
    margin-left: 15px
}

.el-upload-list__item-actions .el-upload-list__item-delete {
    position: static;
    font-size: inherit;
    color: inherit
}

.el-upload-list__item-actions:hover {
    opacity: 1
}

.el-upload-list__item-actions:hover span {
    display: inline-block
}
</style>
